import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';

export default function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className="page">
      <h1>404</h1>
      <p className="muted">{t('common.error')}</p>
      <Link className="btn btn--primary" to="/">
        {t('app.name')}
      </Link>
    </div>
  );
}
